// Field-level validation for the TPRM request form — same touched/error
// pattern as the contract form (useContractFormWorkflow), kept in its own
// module because the form page and the step components both need it.

// The three fields submission actually requires, with where they live —
// so validation errors can name what's missing and jump to the right step.
export const REQUEST_REQUIRED_FIELDS = [
  { key: 'vendorName', label: 'Vendor name', step: 1 },
  { key: 'lightsparkEntity', label: 'Lightspark entity', step: 2 },
  { key: 'serviceOwner', label: 'Service owner', step: 2 },
];

// Fields validated per step, so Next can surface inline errors for the step
// being left without touching fields the requester hasn't reached yet.
export const REQUEST_STEP_FIELDS = {
  1: ['vendorName', 'vendorEmail'],
  2: ['lightsparkEntity', 'serviceOwner'],
};

const FIELD_STEP = Object.entries(REQUEST_STEP_FIELDS).reduce(
  (acc, [step, keys]) => {
    keys.forEach((key) => { acc[key] = Number(step); });
    return acc;
  },
  {}
);

export function requestFieldStep(name) {
  return FIELD_STEP[name] || 1;
}

export function validateRequestFormField(name, value) {
  const text = String(value ?? '').trim();
  switch (name) {
    case 'vendorName':
      if (!text) return 'Vendor name is required';
      break;
    case 'lightsparkEntity':
      if (!text) return 'Lightspark entity is required';
      break;
    case 'serviceOwner':
      if (!text) return 'Service owner is required';
      break;
    case 'vendorEmail':
      if (text && !/^\S+@\S+\.\S+$/.test(text)) return 'Enter a valid email address';
      break;
    default:
      break;
  }
  return null;
}

export function validateRequestFormData(formData) {
  return Object.keys(formData).reduce((acc, key) => {
    const error = validateRequestFormField(key, formData[key]);
    return error ? { ...acc, [key]: error } : acc;
  }, {});
}

export function missingRequiredRequestFields(formData) {
  return REQUEST_REQUIRED_FIELDS.filter(
    (field) => !String(formData[field.key] || '').trim()
  );
}
